import { analytics, logEvent } from "../firebase";

export const gaCustomEvent = (eventName, buttonClickName, customerId) => {
  if(!analytics) {
    console.warn("Analytics is not initialized.");
    return;
  }

  try {
    logEvent(analytics, eventName, {
      buttonName: buttonClickName,
      app_customer_id: customerId,
      debug_mode: true, // enable debug mode for UAT testing
    });
  } catch (error) {
    console.error("Error logging custom event:", error);
  }
};

export const toAlphabets = (raw, onError) => {
  if (onError && /[^a-zA-Z\s]/.test(`${raw ?? ""}`)) {
    onError();
  }
  return `${raw ?? ""}`
    .replace(/[^a-zA-Z\s]/g, "")
    .replace(/^\s+/, "")
    .replace(/\s{2,}/g, " ");
};